import { BusinessHealthChannel } from '../types';

const WIN_RATE_COMPARE_EPS = 1e-6;

export type ChannelWinRateVsBaselineStatus = 'healthy' | 'stable' | 'at_risk';

const getChannelWinRateVsBaselineStatus = (
    channel: BusinessHealthChannel,
): ChannelWinRateVsBaselineStatus | null => {
    const winRate = channel.metrics.win_rate?.current;
    const baseline = channel.baselines?.win_rate;
    if (!Number.isFinite(winRate) || !Number.isFinite(baseline)) {
        return null;
    }
    if (winRate > baseline + WIN_RATE_COMPARE_EPS) return 'healthy';
    if (winRate < baseline - WIN_RATE_COMPARE_EPS) return 'at_risk';
    return 'stable';
};

export default getChannelWinRateVsBaselineStatus;
